import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'

const RazorpayPaymentPlugin = () => {
  const [configID, setConfigId] = useState(0)
  const [razorPayPaymentConfig, setRazorPayPaymentConfig] = useState<any>({
    isEnabled: true,
    isEnabledIos: true,
    secret_key: '',
    api_key: '',
    isTestMode: false,
    taxPercentage: 18,
  })

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = (event: any) => {
    let name = event.target.name
    let value = event.target.checked

    if (name === 'isEnabled' || name === 'isEnabledIos' || name === 'isTestMode') {
      setRazorPayPaymentConfig({...razorPayPaymentConfig, [name]: value})
      updateConfiguration({...razorPayPaymentConfig, [name]: value})
    } else if (name === 'taxPercentage') {
      let rawVal = event.target.value
      if (rawVal === '') {
        setRazorPayPaymentConfig({...razorPayPaymentConfig, [name]: ''})
        return
      }
      let val = parseFloat(rawVal)
      if (isNaN(val)) return
      if (val < 0) val = 0
      if (val > 100) val = 100
      setRazorPayPaymentConfig({...razorPayPaymentConfig, [name]: val})
    } else {
      setRazorPayPaymentConfig({...razorPayPaymentConfig, [name]: event.target.value})
    }
  }

  const onBlurUpdate = () => {
    let finalConfig = {...razorPayPaymentConfig}
    if (finalConfig.taxPercentage === '' || isNaN(parseFloat(finalConfig.taxPercentage))) {
      finalConfig.taxPercentage = 18
      setRazorPayPaymentConfig(finalConfig)
    }
    updateConfiguration(finalConfig)
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('razorpay')
    if (result.success) {
      let parsedData = JSON.parse(result.data.values)
      setConfigId(result.data.id)
      setRazorPayPaymentConfig({
        isEnabled: parsedData?.isEnabled ?? false,
        isEnabledIos: parsedData?.isEnabledIos ?? true,
        api_key: parsedData?.api_key ?? '',
        secret_key: parsedData?.secret_key ?? '',
        isTestMode: parsedData?.isTestMode ?? false,
        taxPercentage: parsedData?.taxPercentage ?? 18,
      })
    }
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)
    if (result.success) {
      getConfiguration()
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  return (
    <div className='card'>
      <div className='card-title p-8'>
        <h2>RazorPay Payment settings</h2>
      </div>
      <div className='card-body'>
        <div className='row no-gutters'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Razor Pay plugin</strong>
            </p>
            <p className='text-muted'>Enable or disable Razor Pay plugin</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='razorpayisEnabled'
                name='isEnabled'
                checked={razorPayPaymentConfig.isEnabled}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Razor Pay plugin for iOS</strong>
            </p>
            <p className='text-muted'>Enable or disable Razor Pay plugin for iOS</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='razorpayisEnabledIos'
                name='isEnabledIos'
                checked={razorPayPaymentConfig.isEnabledIos}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Live APi Key</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex w-100'>
              <input
                type='text'
                className='form-control'
                name='api_key'
                value={razorPayPaymentConfig.api_key}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Live Secret Key</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex w-100'>
              <input
                type='text'
                className='form-control'
                name='secret_key'
                value={razorPayPaymentConfig.secret_key}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Enable Test Mode</strong>
            </p>
            <p className='text-muted'>Toggle sandbox / live mode. When enabled, payments hit test environment.</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='razorpayTestMode'
                name='isTestMode'
                checked={razorPayPaymentConfig.isTestMode}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Tax Percentage (%)</strong>
            </p>
            <p className='text-muted'>Dynamic percentage between 0 and 100</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex w-100'>
              <input
                type='number'
                min='0'
                max='100'
                step='any'
                className='form-control'
                name='taxPercentage'
                placeholder='e.g. 18'
                value={razorPayPaymentConfig.taxPercentage}
                onChange={(event) => handleChange(event)}
                onBlur={onBlurUpdate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RazorpayPaymentPlugin
